<template>
  <div class="content t-c">
    <title-bar :title="$lang.common_txt296"></title-bar>
    <div style="padding: 10px">
      <div
        v-if="currentFavorites.length > 0"
        class="d-flex"
        style="flex-flow: wrap row"
      >
        <div
          v-for="(item, index) in currentFavorites"
          :key="index"
          style="width: 33.3%; margin-bottom: 5px"
          @click="goToGame(item)"
        >
          <img
            :src="item.gameIcon"
            style="border-radius: 10px; width: 92%; max-height: 150px"
          />
        </div>
      </div>
      <van-empty
        v-else
        :image="require('../../../assets/img/common/img_no_data.png')"
        :description="$lang.noempt"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { toArray } from './safeFlow'
import { buildLaunchPayload, launchGame } from '@/components/home/gameLaunch'
import { gameUnavailableMessage, isUnavailableGameEntry } from '@/views/details/home/gameResponse'

const FAVORITE_LIST_KEYS = ['list', 'items', 'records', 'dataList', 'games', 'gameList', 'game_list']
const FAVORITE_CURRENCY_KEYS = ['currency', 'currencyCode', 'currency_code', 'country', 'countryCode', 'country_code']
const GAME_ID_KEYS = ['gid', 'gameId', 'game_id', 'gameCode', 'game_code']
const GAME_ICON_KEYS = ['gameIcon', 'game_icon', 'icon', 'iconUrl', 'icon_url', 'image', 'imageUrl', 'image_url', 'logo']

function firstValue(source, keys) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of keys) {
    const value = data[key]
    if (value !== undefined && value !== null && String(value).trim() !== '') return value
  }
  return ''
}

function favoriteCurrency(source) {
  return String(firstValue(source, FAVORITE_CURRENCY_KEYS)).trim()
}

function favoriteList(source) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of FAVORITE_LIST_KEYS) {
    if (Array.isArray(data[key])) return data[key]
  }
  return []
}

function normalizeFavoriteGame(item) {
  if (!item || typeof item !== 'object') return null
  const gid = firstValue(item, GAME_ID_KEYS)
  if (!gid) return null
  return {
    ...item,
    gid,
    gameIcon: firstValue(item, GAME_ICON_KEYS)
  }
}

function normalizeFavoriteRows(rows) {
  return toArray(rows)
    .map(normalizeFavoriteGame)
    .filter(item => item && !isUnavailableGameEntry(item))
}

export default {
  name: 'myCollection',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState(['favorites']),
    currentFavorites() {
      const favorites = toArray(this.favorites)
      const currencyGroup = favorites.find(item => item && favoriteCurrency(item) === this.getCurrency)
      if (currencyGroup) {
        return normalizeFavoriteRows(favoriteList(currencyGroup))
      }
      return normalizeFavoriteRows(favorites.filter(item => item && !FAVORITE_LIST_KEYS.some(key => Array.isArray(item[key]))))
    }
  },
  mounted() {},
  methods: {
    goToGame(item) {
      if (this.token) {
        if (!item || isUnavailableGameEntry(item)) {
          this.$toast({
            message: gameUnavailableMessage(this.$lang.common_txt160),
            icon: 'cross'
          })
          return
        }
        const jumpPayload = buildLaunchPayload(item, { typeCate: 1 })
        launchGame(this, jumpPayload)
      } else if (this.$bus) {
        this.$bus.$emit('openLogin')
      } else {
        this.$jumpTo('/home', {}, { replace: true })
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
